import { CheckboxFieldReduxFormWrapper, Icon, PopupTooltip } from '@adc/ui-adc'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import { Field } from 'redux-form'

export const TagWithTooltip = ({ label, tooltipLabel, elmId }) => {
  return (
    <div style={{ display: 'flex', gap: '6px' }}>
      {label}
      <PopupTooltip
        on='hover'
        position='right center'
        offset={0}
        trigger={<Icon name='info circle' fitted />}
        content={tooltipLabel}
        data-elm-id={elmId}
      />
    </div>
  )
}

TagWithTooltip.propTypes = {
  label: PropTypes.string,
  tooltipLabel: PropTypes.string,
  elmId: PropTypes.string,
}

const TagCheckbox = ({ submitForms, label, name }) => (
  <Field
    compact
    type='checkbox'
    name={name}
    elmId={`featured_filters_${name}`}
    onChange={submitForms}
    label={label}
    component={CheckboxFieldReduxFormWrapper}
    key={name}
  />
)

TagCheckbox.propTypes = {
  submitForms: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

const FeaturedFiltersContent = ({
  submitForms,
  marketingTagsConfig,
  className,
}) => {
  return (
    <section className={className} data-elm-id='featured_filters'>
      <section>
        {marketingTagsConfig.map(config => {
          const { srp = {} } = config.configuration
          const tagLabel =
            srp.is_tooltip_active && srp.tooltip?.length ? (
              <TagWithTooltip
                label={srp.label}
                tooltipLabel={srp.tooltip}
                elmId={`${config.tag}_tooltip_content`}
              />
            ) : (
              srp.label
            )
          return (
            <TagCheckbox
              key={config.tag}
              submitForms={submitForms}
              label={tagLabel}
              name={config.tag}
            />
          )
        })}
      </section>
    </section>
  )
}

FeaturedFiltersContent.propTypes = {
  submitForms: PropTypes.func.isRequired,
  marketingTagsConfig: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
}

export default connect()(FeaturedFiltersContent)
